export default function useEnabledCustomFieldIds(customFields, display) {
  const enabledCustomFieldIds = Object.entries(display)
    .filter(
      ([key, value]) => value && key.startsWith("custom_field_") && /custom_field_\d+/.test(key)
    )
    .map(([key]) => {
      const number = key.split("custom_field_")[1];
      return number;
    });

  return customFields.filter(field => enabledCustomFieldIds.includes(field.id));
}
